export const getOffset = (page: number, rowsPerPage: number) => {
    return page ? (page - 1
    ) * rowsPerPage : 0;
};
